<template>
  <div class="pageStyle">
    <div class="pageBox">
      <div class="header">
        <div>{{ title }}</div>
        <div>
          <span>夹层数据</span><span>共{{ dataList.length }}条</span>
        </div>
      </div>
      <div class="content">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell v-for="(item, index) in dataList" :key="index">
            <div class="item">
              <div v-show="item.companyName">
                <span>企业名称：</span>{{ item.companyName }}
              </div>
              <div v-show="item.applyName">
                <span>姓名：</span>{{ item.applyName }}
              </div>
              <div v-show="item.idCard">
                <span>身份证号：</span>{{ item.idCard }}
              </div>
              <div v-show="item.createDateTime">
                <span>提交时间：</span>{{ parseTime(item.createDateTime) }}
              </div>
            </div>
            <template #right>
              <van-button
                @click="copyTxt(item)"
                square
                type="primary"
                text="复制"
              />
              <!-- <van-button @click="del(item)" square type="danger" text="删除" /> -->
            </template>
          </van-swipe-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { SwipeCell, Button, Dialog, Toast, Notify, List } from "vant";
import { getXcLayerData,getXcLayerCodeFormId } from "@/api/layerCode";
Vue.use(SwipeCell);
Vue.use(Button);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Notify);
Vue.use(List);
import Vue from "vue";
export default {
  components: {},
  data() {
    return {
      activeName: "",
      dataList: [],
      query: {
        layerCodeId: "",
        size: 10,
        page: 0,
        sort: "createDateTime,desc",
      },
      loading: false,
      finished: false,
      title: "",
    };
  },

  mounted() {
    let code = this.$route.query.code;
    if (code) {
      this.query.layerCodeId = code;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      getXcLayerCodeFormId(code).then((res) => {
        this.title = res.layerName;
      });
      // this.getData();
    } else {
      Notify({ type: "danger", message: "参数错误" });
      this.$router.push({ path: "/layerCode" });
    }
  },

  methods: {
    getData() {
      getXcLayerData(this.query).then((res) => {
        Toast.clear();
        this.dataList = this.dataList.concat(res.content);
        this.query.page++;
        this.loading = false;
        if (res.content.length == 0) {
          this.finished = true;
        }
      });
    },
    onLoad() {
      this.loading = true;
      this.getData();
    },
    copyTxt(row) {
      let txt = row.companyName
        ? "企业名称：" +
          row.companyName +
          "\n提交时间：" +
          this.parseTime(row.createDateTime)
        : "姓名：" +
          row.applyName +
          "\n身份证号：" +
          row.idCard +
          "\n提交时间：" +
          this.parseTime(row.createDateTime);
      let textarea = document.createElement("textarea");
      document.body.appendChild(textarea);
      // 赋值内容
      textarea.value = txt;
      // 选定
      textarea.select();
      // 执行浏览器复制
      document.execCommand("Copy");
      // 复制完后移除textarea
      document.body.removeChild(textarea);
      Toast.success("已复制");
    },
    del(row) {
      let txt = row.companyName
        ? "确认删除该条记录？<br>企业名称：" + row.companyName
        : "确认删除该条记录？<br>姓名：" + row.applyName;
      Dialog.confirm({
        title: "提示",
        message: txt,
      })
        .then(() => {
          console.log("row.id", row.id);
        })
        .catch(() => {
          // on cancel
        });
    },
    parseTime(time) {
      if (time) {
        var date = new Date(time);
        var year = date.getFullYear();
        /* 在日期格式中，月份是从0开始的，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        var month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // 拼接
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/layerCode/module/layerCodeDataList/index.vue